class Accordion extends HTMLElement {
  accordionBtn = undefined;
  accordionContent = undefined;

  constructor() {
    super();
    this.accordionBtn = this.querySelector('button');
    this.accordionWrapper = this.querySelector('.accordion-wrapper');
  }

  connectedCallback() {
    this.accordionBtn.addEventListener('click', () => {
      this.accordionWrapper.classList.toggle('open');
      const expandedState =
        this.accordionBtn.ariaExpanded === 'false' ? 'true' : 'false';
      this.accordionBtn.ariaExpanded = expandedState;
    });
  }
}

customElements.define('custom-accordion', Accordion);

// dropdowns for currency and language
(function () {
  function closeAllDropdowns(except) {
    document.querySelectorAll('.dropdown').forEach(function (drop) {
      if (drop !== except) {
        drop.classList.remove('open');
        drop
          .querySelector('.dropdown-toggle')
          .setAttribute('aria-expanded', 'false');
      }
    });
  }

  function initializeDropdown(dropdown) {
    const toggle = dropdown.querySelector('.dropdown-toggle');
    const menu = dropdown.querySelector('.dropdown-menu');
    const options = dropdown.querySelectorAll('.dropdown-option');

    toggle.addEventListener('click', function (e) {
      const expanded = dropdown.classList.toggle('open');
      this.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      closeAllDropdowns(dropdown);
      if (expanded && menu) {
        menu.focus();
      }
    });

    options.forEach(function (option) {
      option.addEventListener('click', function (e) {
        const label = this.querySelector('.dropdown-label').textContent;
        const flag = this.querySelector('.flag-icon').textContent;
        toggle.querySelector('.dropdown-label').textContent = label;
        toggle.querySelector('.flag-icon').textContent = flag;
        dropdown.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      });

      option.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });

    if (menu) {
      menu.addEventListener('keydown', function (e) {
        const optionsArray = Array.from(options);
        const current = document.activeElement;
        const idx = optionsArray.indexOf(current);

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const next = optionsArray[(idx + 1) % optionsArray.length];
          next.focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          const prev =
            optionsArray[(idx - 1 + optionsArray.length) % optionsArray.length];
          prev.focus();
        } else if (e.key === 'Escape') {
          e.preventDefault();
          dropdown.classList.remove('open');
          toggle.setAttribute('aria-expanded', 'false');
          toggle.focus();
        }
      });
    }
  }

  // Initialize all dropdowns on the page
  document.querySelectorAll('.dropdown').forEach(initializeDropdown);

  // Close dropdowns when clicking outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.dropdown')) {
      closeAllDropdowns();
    }
  });

  // Close dropdowns on Escape globally
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllDropdowns();
    }
  });

  document.querySelectorAll('details').forEach((details) => {
    details.addEventListener('toggle', (e) => {
      e.target
        .querySelector('summary')
        .setAttribute('aria-expanded', e.target.open);
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
  const stickyCollectionHeader = document.querySelector('aside.facets-wrapper.container__max-width');
  
  if (stickyCollectionHeader) {
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyCollectionHeader.style.borderBottom = '2px solid var(--container-content)';
        } else {
          stickyCollectionHeader.style.borderBottom = 'none';
        }
      });
    }, {
      threshold: 0,
      rootMargin: '0px 0px -100% 0px'
    });
    
    observer.observe(stickyCollectionHeader);
  }
});
})();


    //Cookie Consent Bar Positioning
    let skipLink = document.querySelector('.skip-to-content-link');
    
    function positionConsentModule() {
        const consentModule = document.getElementById('truyo-consent-module');
        if (!consentModule) return false;
        
        if (skipLink.nextElementSibling !== consentModule) {
            consentModule.parentNode.removeChild(consentModule);
            skipLink.parentNode.insertBefore(consentModule, skipLink.nextSibling);
        }
        if (consentModule) {
            consentModule.setAttribute('role', 'region');
            consentModule.setAttribute('aria-label', 'Cookie consent banner');
            const scheme = document.body.dataset.cartColorScheme;
            if (scheme) {
                consentModule.classList.add(scheme, 'container__background');
            }
        }
        return true;
    }
    
    let attempts = 0;
    const maxAttempts = 50;
    
    const waitForConsent = setInterval(() => {
        attempts++;
        
        if (positionConsentModule()) {
            clearInterval(waitForConsent);
        } else if (attempts >= maxAttempts) {
            clearInterval(waitForConsent);
        }
    }, 100);

    new MutationObserver(() => positionConsentModule())
        .observe(document.body, { childList: true, subtree: true });
  //Cookie Consent bar positioning end

  window.addEventListener('DOMContentLoaded', function(e) {
  var floating_labels = document.querySelectorAll('.floating-label');
  floating_labels.forEach(label_container => {
    var input = label_container.querySelector('input');
    input.addEventListener('focus', function(e) {
      label_container.classList.add('has-focus');
      label_container.classList.add('is-floating');
    });
    input.addEventListener('blur', function(e) {
      label_container.classList.remove('has-focus');
      
      if(e.target.value == '') {
        label_container.classList.remove('is-floating');
      }
    });
  });
});